(() => {
    Metro.i18n.add("zh-TW", {
        weekStart: 0,

        january: "一月",
        february: "二月",
        march: "三月",
        april: "四月",
        may: "五月",
        june: "六月",
        july: "七月",
        august: "八月",
        september: "九月",
        october: "十月",
        november: "十一月",
        december: "十二月",

        january_short: "1月",
        february_short: "2月",
        march_short: "3月",
        april_short: "4月",
        may_short: "5月",
        june_short: "6月",
        july_short: "7月",
        august_short: "8月",
        september_short: "9月",
        october_short: "10月",
        november_short: "11月",
        december_short: "12月",

        sunday: "星期日",
        monday: "星期一",
        tuesday: "星期二",
        wednesday: "星期三",
        thursday: "星期四",
        friday: "星期五",
        saturday: "星期六",

        sunday_short: "週日",
        monday_short: "週一",
        tuesday_short: "週二",
        wednesday_short: "週三",
        thursday_short: "週四",
        friday_short: "週五",
        saturday_short: "週六",

        sunday_short_2: "日",
        monday_short_2: "一",
        tuesday_short_2: "二",
        wednesday_short_2: "三",
        thursday_short_2: "四",
        friday_short_2: "五",
        saturday_short_2: "六",

        label_ok: "確定",
        label_cancel: "取消",
        label_done: "完成",
        label_today: "今天",
        label_now: "現在",
        label_clear: "清除",
        label_help: "說明",
        label_yes: "是",
        label_no: "否",
        label_random: "隨機",
        label_save: "儲存",
        label_reset: "重設",
        label_submit: "提交",
        label_add_user_color: "加入色票",
        label_send: "傳送",
        label_accept: "接受",
        label_cookies_title: "此網站使用Cookie",
        label_cookies_text: "本網站使用Cookie，以確保您在我們網站上獲得最佳體驗。",
        label_choose_file: "選擇檔案",
        label_drop_file: "點擊或拖放檔案至此",
        label_files_selected: "已選擇 {n} 個檔案",

        label_days: "天",
        label_hours: "小時",
        label_minutes: "分鐘",
        label_seconds: "秒",
        label_month: "月",
        label_months: "月",
        label_day: "日",
        label_year: "年",
        label_years: "年",

        label_rows_count: "顯示：",
        label_search: "搜尋：",
        label_table_info: "顯示第 $1 到 $2 項，共 $3 項",
        label_prev: "上一頁",
        label_next: "下一頁",
        label_all: "全部",
        label_inspector: "檢查器",
        label_goto_page: "前往",
        label_enter_page: "輸入頁碼...",
        label_empty: "沒有資料可顯示",
        label_user_colors: "使用者顏色",
        label_tiles: "磚塊",
        label_list: "清單",
        label_load_more: "載入更多",
        label_buy: "購買",
        label_buy_now: "立即購買",
        label_buy_today: "今日購買",
        label_download: "下載",
        label_search_results: "搜尋結果",
        label_add: "新增",
        label_edit: "編輯",
        label_delete: "刪除",
        label_new: "新建",
        label_sell: "出售",
        label_details: "詳細資料",
        label_sorting: "排序",
        label_finish: "完成",
        label_play: "播放",
        label_pause: "暫停",
        label_stop: "停止",
        label_mute: "靜音",
        label_loop: "循環",

        label_on: "開啟",
        label_off: "關閉",

        label_rename_tab: "重新命名分頁",
        label_close_tab: "關閉分頁",
        label_close_other_tabs: "關閉其他分頁",
        label_close_tabs_left: "關閉左側分頁",
        label_close_tabs_right: "關閉右側分頁",
        label_close_all_tabs: "關閉所有分頁",
        label_close_inactive_tabs: "關閉非活動分頁",

        label_clear_input: "清除輸入",
        label_reveal_password: "顯示密碼",
        label_hide_password: "隱藏密碼",
        label_generate_random: "產生隨機值",
        label_search_input: "搜尋輸入的值",

        label_note: "備註",
        label_tip: "提示",
        label_info: "資訊",
        label_warning: "警告",
        label_question: "問題",
        label_error: "錯誤",
        label_success: "成功",
        label_caution: "注意",
        label_alert: "警示",
        label_bug: "錯誤",
        label_fuck: "該死",
        label_important: "重要",
        label_shit: "糟糕",
        label_air: "空氣",

        label_select_all: "全選",
        label_select_more: "選擇...",
        label_select: "選擇",
        label_filter: "篩選",

        label_collapse: "收合",
        label_attach: "附加",
    });
})();
